import { asset } from "@/lib/asset";
import { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons';

export const SlideTemplate = ({ slideId, imgDir, slides }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % slides.length);
    }, 10000);

    return () => clearInterval(intervalRef.current);
  }, [slides.length]);

  const handleUserInteraction = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleUserInteraction);
    window.addEventListener('keydown', handleUserInteraction);

    return () => {
      window.removeEventListener('click', handleUserInteraction);
      window.removeEventListener('keydown', handleUserInteraction);
    };
  }, []);

  return (
    <section className="bg-white pb-4 xl:pb-8 xl:pb-[0px]">
      <div
        id={`carousel-${slideId}`}
        className="relative"
      >
        <div className="relative min-h-[430px] md:h-[555px] lg:h-[680px] xl:h-[445px]">
          {slides.map((slide, i) => (
            <div
              key={slide.id}
              className={`absolute inset-0 transition-opacity duration-300 ${activeSlide === i ? 'opacity-100' : 'opacity-0'
                }`}
            >
              <div className="text-center xl:mt-[25px]">
                <img
                  src={asset(`/img/${imgDir}/${slide.id}.png`)}
                  className="w-full max-w-full xl:w-[700px] rounded-[1px] mx-auto"
                  loading="lazy"
                />
                <div className="mt-4 max-w-3xl mx-auto xl:mt-[0px]">
                  {slide.text}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center gap-[40px] xl:mt-[75px]">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`w-3.5 h-3.5 rounded-full ${activeSlide === i ? 'bg-[#ffb805]' : ' bg-[#d9d9d9]'
                }`}
              onClick={() => setActiveSlide(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>

        <div className="hidden xl:flex justify-between absolute top-0 xl:top-[180px] w-full max-w-full xl:w-[996px] left-1/2 -translate-x-1/2">
          <button
            className="w-10 xl:w-[120px] h-10 rounded-full hover:bg-white flex items-center justify-end"
            onClick={() => setActiveSlide(prev => Math.max(0, prev - 1))}
          >
            <FontAwesomeIcon icon={faAngleLeft} className="text-[#544A28] text-2xl xl:text-[40px]" />
          </button>
          <button
            className="w-10 xl:w-[120px] h-10 rounded-full hover:bg-white flex items-center justify-start"
            onClick={() => setActiveSlide(prev => Math.min(slides.length - 1, prev + 1))}
          >
            <FontAwesomeIcon icon={faAngleRight} className="text-[#544A28] text-2xl xl:text-[40px]" />
          </button>
        </div>

      </div>
    </section>
  );
}; 